import { createStore } from 'redux';
import reducers from './reducers';
import actions  from './actions';

// Set redux store
export const store = createStore(reducers);

// Map redux obj for use
export const redux = {
	store: (key) => {
		// Get by key
		if (key) return store.getState()[key];
		// Get full store
		return store.getState();		
	},

	actions: {
		account : actions.account(store.dispatch),
		layout  : actions.layout(store.dispatch),
		user    : actions.user(store.dispatch)
	}
};

export default redux;